/* eslint-disable no-underscore-dangle */

const guidStorage = require('./guid_storage.js');
const Analytics = require('../common-js-helpers/analytics');

const SessionInfo = require('../ot/session/SessionInfo');
const StaticConfig = require('../helpers/StaticConfig')();

const eventing = require('./eventing');
const sanitizeQosData = require('../helpers/sanitizeQosData');

const LOG_VERSION = '2';

class AnalyticsHelper {
  constructor({
    staticConfig = StaticConfig.onlyLocal(),
    sessionInfo = new SessionInfo(),
    ajax,
    queue,
  } = {}) {
    this.ajax = ajax;
    this.queue = queue;
    this.sessionInfo = sessionInfo;
    this.staticConfig = staticConfig;
  }

  get staticConfig() {
    return this._staticConfig;
  }

  set staticConfig(staticConfig) {
    this._staticConfig = staticConfig;
    this._analytics = new Analytics({
      loggingUrl: this.staticConfig.loggingUrl,
      ajax: this.ajax,
      queue: this.queue,
    });
  }

  _getCommon() {
    return {
      clientVersion: this.staticConfig.clientVersion,
      buildHash: this.staticConfig.buildHash,
      source: global.location && global.location.href,
      logVersion: LOG_VERSION,
      apiServer: this.staticConfig.apiUrl,
      clientSystemTime: new Date().getTime(),
      sessionId: this.sessionInfo.sessionId,
      mediaServerName: this.sessionInfo.mediaServerName,
      relayServer: this.getTurnServerName(this.sessionInfo.iceServers),
      p2p: this.sessionInfo.p2pEnabled,
      messagingServer: this.sessionInfo.messagingServer,
      messagingUrl: this.sessionInfo.messagingURL,
      version: this.staticConfig.version,
      partnerId: this.sessionInfo.partnerId,
    };
  }

  getTurnServerName = (iceServers) => {
    let turnNoTLSServerName;
    let turnTLSServerName;

    // In case we don't find the server name we will be returning nothing
    // which will be ignored and relay server will not be present in the logs
    if (!iceServers || typeof iceServers !== 'object') return turnNoTLSServerName;

    const servers = Array.isArray(iceServers) ? iceServers : [iceServers];
    servers.forEach((server) => {
      const urls = server.urls || server.url;
      const arrUrl = Array.isArray(urls) ? urls : [urls];
      arrUrl.forEach((url) => {
        // Index where server name value starts
        const prefixIndex = url.indexOf(':') + 1;
        // Index of the port number
        const suffixIndex = url.lastIndexOf(':');

        // We assume that TLS turn, i.e. turns, is the one which contains
        // the domain name.
        if (url.includes('turns')) {
          turnTLSServerName = url.substring(prefixIndex, suffixIndex);
        } else {
          turnNoTLSServerName = url.substring(prefixIndex, suffixIndex);
        }
      });
    });
    return turnTLSServerName || turnNoTLSServerName;
  }

  logError(code, type, message, details, options = {}) {
    guidStorage.get((error, guid) => {
      if (error) {
        // @todo
        return;
      }
      const args = [code, type, message, details, { guid, ...this.combineWithCommon(options) }];
      AnalyticsHelper.emit('logError', ...args);
      this._analytics.logError(...args);
    });
  }

  combineWithCommon(options) {
    return {
      ...this._getCommon(),
      ...options,
    };
  }

  logEvent(options = {}, throttle, completionHandler) {
    guidStorage.get((error, guid) => {
      if (error) {
        // @todo
        return;
      }

      const logData = { guid, ...this.combineWithCommon(options) };
      AnalyticsHelper.emit('logEvent', logData);

      this._analytics.logEvent(
        logData,
        false,
        throttle,
        completionHandler
      );
    });
  }

  logQOS(options = {}) {
    guidStorage.get((error, guid) => {
      if (error) {
        // @todo
        return;
      }
      const qosData = { guid, duration: 0, ...this.combineWithCommon(options) };

      sanitizeQosData(qosData);

      AnalyticsHelper.emit('logQOS', qosData);
      this._analytics.logQOS(qosData);
    });
  }
}

eventing(AnalyticsHelper);

module.exports = AnalyticsHelper;
